<template>
  <div class="movie-hall page">
    <van-tabs v-model="active" animated swipeable @change="OnChange">
      <van-tab v-for="(v,key) in videolitem" :key="key" :title="v.name" :name="v.key"></van-tab>
    </van-tabs>
    <swiper class="video_swiper" ref="swiper" :options="videoSwiperOption" @slideChange="itemChange">
      <swiper-slide v-for="(v,key) in videolitem" :key="key">
        <div class="movie-list-tab">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('msg.下拉即可刷新')"
                            :loosing-text="$t('msg.释放即可刷新')" :loading-text="$t('msg.加载中')">
            <div class="hot-recommend-div">
              <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :loading-text="$t('msg.加载中')"
                  :finished-text="$t('msg.没有更多了')"
                  @load="onLoad"
              >
                <div class="list-item">
                  <div class="movie_list_1">
                    <div class="movie-list-item" v-for="(v,key) in videolist" :key="key" @click="toPlayVideo(v.id)">

                      <van-image class="cover_img" round :src="v.vod_pic">
                        <template v-slot:loading>
                          <van-loading type="circular"/>
                        </template>
                      </van-image>
                      <div class="movie-list-item-bottom">
                        <div class="movie-time-div">{{ v.vod_name }}</div>
                      </div>
                    </div>
                  </div>


                </div>
              </van-list>

            </div>
          </van-pull-refresh>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {Toast} from 'vant';

export default {
  data() {
    return {
      active: 0,
      isLoading: false,
      count: 0,
      mail: 0,
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      videolist: [],
      number: 0,
      page: 0,
      videoSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      }
    };
  },
  methods: {

    toMail() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Mail'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    getVideoClass() {
      this.$http({
        method: 'get',
        url: 'video_class'
      }).then(res => {
        this.videolitem = res.data;
      })
    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/PlayVideo?id=' + id})
      }

    },
    itemChange() {
      this.active = this.$refs.swiper.swiper.activeIndex
      this.OnChange()
    },
    getVideoList() {
      this.$http({
        method: 'get',
        data: {id: this.active, page: this.page},
        url: 'video_list'
      }).then(res => {
        this.videolist = this.videolist.concat(res.data.data);
        this.count = res.data.count;
        this.page++;

      })
    },
    onLoad() {
      this.getVideoList();
      let timer = setTimeout(() => {
        if (this.refreshing) {
          this.videolist = [];
          this.refreshing = false;
        }
        this.loading = false;
        if (this.videolist.length === this.count) {
          this.finished = true;
        }
        this.finished && clearTimeout(timer);//清除计时器
      }, 500);
    },
    OnChange() {
      this.videolist = [];
      this.number = 0;
      this.page = 0;
      this.count = 0;
      this.getVideoList();//获取视频列表

    },
    onRefresh() {
      setTimeout(() => {
        this.finished = false;
        this.loading = true;
        this.onLoad();
        this.isLoading = false;
        Toast(this.$t("msg.刷新成功！"));
      }, 500);
    },

    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          this.mail = res.data.mail;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path: '/Login'})
          }
        } else if (res.code === 401) {
          //this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    this.getVideoClass();//获取视频类目
    this.OnChange();
    this.getUserInfo();
  }
};
</script>

<style lang='less' scoped>

.movie_list_1 .movie-time-div {
  color: #fff;
  border-radius: 0 0 1.333vw 1.333vw;
  height: 8.667vw;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制显示的行数为3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  align-items:flex-start

}
</style>
